export function range(start:number, end: number): number[] {
    const numbers = [];
    for (let i = start; i < end + 1; i++) {
        numbers.push(i);
    }
    return numbers;
}